import logoLogin from "../../img/png/logo_login.png";
import {exibirMensagemErro, exibirMensagemSucesso, formatarData, HttpVerbo, xfetch} from "../../util";
import React, {useEffect, useState} from "react";
import {BotaoEnviar} from "../../componentes";
import {useNavigate, useParams} from "react-router-dom";
import {CirastServico} from "../../servicos";

export default function AtendimentoCirast() {

  const params = useParams()
  const navegacao = useNavigate()

  const [dados, setDados] = useState({})
  const [cpf, setCpf] = useState('')
  const [cnpj, setCnpj] = useState('')
  const [atendente, setAtendente] = useState('')

  function enviar() {
    const atendimento = {
      cpfCliente: cpf,
      nomeAtendente: atendente,
      cnpjClinica: cnpj,
      idConsulta: params.id
    }
    CirastServico.registrarAtendimento(atendimento)
      .then(res => res.json() & console.log(res))
      .then(s => {
        exibirMensagemSucesso("Atendimento registrado com sucesso.")
        navegacao('/')
      })

  }

  function buscarDados() {
    xfetch('/publica/dados/atendimento-cirast/'+ params.id, {}, HttpVerbo.GET)
      .then(res => res.json())
      .then(dados => setDados(dados))
      .catch(() => exibirMensagemErro("Erro ao carregar consulta"))
  }

  useEffect(() => {
    buscarDados()
  },[])

  return (
    <div className="row">
      <div className="col-lg-12 text-center mt-5">
        <div className="card">
          <div className="card-header text-center">
            <img src={logoLogin}  alt={"logo asplan"}/>
          </div>
          <div className="card-body text-center mt-3">
            <div className="col-lg-12"> <p> Paciente: <b>{dados.paciente}</b> </p></div>
            <div className="col-lg-12"> <p> Nome da clinica: <b>{dados.nomeClinica}</b> </p></div>
            <div className="col-lg-12"> <p> Data do atendimento: <b>{formatarData(new Date().toISOString())}</b> </p></div>
            <div className="col-lg-12">

                Situação do voucher:
              <span className={'ml-2' + (dados.isAtivo ? ' badge bg-primary' : ' badge bg-danger')}>
                  {dados.isAtivo ? 'VÁLIDO' : 'INVÁLIDO'}
                </span>
            </div>
            <div className="col-lg-4 offset-lg-4 align-center mt-5">
              <label className="mt-2">Informe o CPF do paciente:</label>
              <input
                className="form-control"
                value={cpf}
                onChange={(e) => setCpf(e.target.value)}
                placeholder="CPF"/>
              <label className="mt-2">Informe o CNPJ da clinica:</label>
              <input
                className="form-control"
                value={cnpj}
                onChange={(e) => setCnpj(e.target.value)}
                placeholder="CNPJ"/>
              <label className="mt-2">Nome do atendente:</label>
              <input
                className="form-control"
                value={atendente}
                onChange={(e) => setAtendente(e.target.value.toUpperCase())}
                placeholder="Nome da atendente"/>
              <BotaoEnviar disabled={!dados.isAtivo} tamanho='col-lg-4 mt-3 ' onClick={enviar}/>
            </div>
          </div>
        </div>

      </div>
    </div>
  )
}